import type { RangeRef } from '../../core';
import type { DictationCheckResult } from 'hooks/useDictationCheck';

export const DICTATION_CHECK_PLUGIN_ID = 'dictationCheck';
export type DictationCheckPluginId = typeof DICTATION_CHECK_PLUGIN_ID;
export type DictationChange = DictationCheckResult['changes'][number];

export interface DictationCheckMark {
  id: string;
  kind: 'suggestion' | 'applied';
  replacement?: string;
  endOffset?: number;
}

export interface DictationCheckItem {
  change: DictationChange;
  status: 'open' | 'applied' | 'accepted' | 'dismissed' | 'reverted' | 'edited';
  wasAutoApplied?: boolean;
  lastResolvedStatus?: 'accepted' | 'dismissed' | 'reverted' | 'edited';
  resolvedText?: string;
  originalLeaves: import('../../core').Text[];
  formatting?: Omit<import('../../core').Text, 'text'>;
  rangeRef: RangeRef;
  replacedText: string;
}
